import {API_URL} from '../constants/index.js';
import {
    POST_REGISTRATION_INFO,
    POST_REGISTRATION_INFO_ERROR,
    POST_REGISTRATION_INFO_SUCCESS

} from '../constants/connectAppConstants';
import {sweetAlert} from '../components/Alert/sweetAlert'

//#region  post registrationCode
export function postRegirtrationInfo(data) {
    return {
        type: POST_REGISTRATION_INFO,
        data
    }
};

export function postRegirtrationInfoSuccess(data) {
    return {
        type: POST_REGISTRATION_INFO_SUCCESS,
        data
    }
};

export function postRegirtrationInfoError(data) {
    return {
        type: POST_REGISTRATION_INFO_ERROR,
        data
    }
};

export function PostRegirtrationInfo(data) {
    return dispatch => {
        dispatch(postRegirtrationInfo());
        
        fetch(API_URL+'registrationFamily',
            {
                method: 'POST',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {
                const message ='Invitation email sent successfully';
                dispatch(postRegirtrationInfoSuccess(res));

                sweetAlert('success', message, 'alert_PostRegistration_Success')
                return res;
            })
            .catch(error => {
                const message ='error sending email';
                dispatch(postRegirtrationInfoError(error));

                sweetAlert('error', message, 'alert_PostRegistration_Error')

            })
    }
};
//#endregion